var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 246,
    viewBox: "0 0 210 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_13717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.218 199.423L163.902 218.026L157.842 206.797L157.943 206.628L171.447 199.575H171.7C172.206 199.423 173.894 199.339 176.173 199.136C180.775 198.853 185.317 197.949 189.677 196.447C192.276 195.415 195.213 195.28 197.053 197.377C197.567 197.972 197.963 198.661 198.218 199.406V199.423Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.797 221.425C136.32 221.543 137.839 222.271 139.949 223.116C144.131 225.072 148.561 226.444 153.115 227.192C155.9 227.53 158.551 228.883 159.175 231.521C159.321 232.293 159.321 233.084 159.175 233.855C159.183 233.911 159.183 233.968 159.175 234.024H120.183V221.222H135.459H135.763L135.797 221.425Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.548 176.372L134.43 173.193C134.48 174.191 134.514 175.273 134.548 176.372Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4623 101.233C90.0294 100.813 90.5026 100.278 90.8514 99.6636C91.2002 99.0491 91.417 98.3684 91.4879 97.665C91.5062 97.3961 91.4659 97.1263 91.3699 96.8745C91.2738 96.6227 91.1243 96.3948 90.9316 96.2066C90.739 96.0184 90.5078 95.8744 90.2541 95.7846C90.0004 95.6947 89.7302 95.6612 89.4623 95.6864C89.3846 95.8826 89.2764 96.0653 89.1416 96.2275L89.3104 93.1665L89.648 86.9768C89.6741 86.7989 89.6646 86.6176 89.6199 86.4434C89.5753 86.2692 89.4965 86.1057 89.388 85.9624C89.2796 85.8191 89.1437 85.6989 88.9884 85.6089C88.833 85.5188 88.6613 85.4607 88.4833 85.4379H88.1457L89.1922 78.2504H96.9906L97.1763 76.0349H87.2173L85.8163 85.4717H81.0225C80.9621 84.6479 80.6668 83.8588 80.1718 83.1983C79.6767 82.5377 79.0028 82.0335 78.23 81.7456C77.4573 81.4577 76.6183 81.3982 75.8128 81.5742C75.0072 81.7502 74.2691 82.1542 73.6861 82.7383C73.1032 83.3224 72.6999 84.0619 72.5242 84.8689C72.3486 85.676 72.408 86.5166 72.6954 87.2908C72.9827 88.065 73.486 88.7403 74.1452 89.2362C74.8045 89.7322 75.5921 90.028 76.4143 90.0886L76.5494 92.7099L76.6844 95.2805H76.4312C75.2979 95.4096 74.2444 95.9286 73.4502 96.7489C72.6561 97.5692 72.1705 98.6401 72.0763 99.779L72.2451 108.336L71.8062 108.489C64.772 110.94 57.5366 112.768 50.1833 113.951C44.3767 114.729 40.2243 114.425 38.3676 112.852C30.7211 106.544 44.0729 67.9849 50.369 61.7783C54.015 58.1761 61.4758 56.6033 70.6246 54.8276C70.9423 53.6556 71.6898 52.647 72.7177 52.0033H72.819C78.428 50.8086 84.219 50.7511 89.8505 51.8342L90.4751 52.0541C91.0923 52.2419 91.6429 52.6029 92.0617 53.0944C92.4805 53.586 92.75 54.1874 92.8382 54.8276C92.8382 54.8276 106.494 56.3328 108.925 59.1739C115.136 66.4629 121.466 73.8871 126.226 78.9945C126.564 79.3496 135.476 70.9952 138.582 62.8269H138.683C138.683 62.8269 142.059 67.9004 147.815 66.9533C147.36 67.8666 132.1 98.3584 124.859 95.7033C118.732 93.4371 112.081 88.4312 105.008 82.4783C102.173 80.0937 113.212 129.544 113.313 130.626H106.123L81.5626 130.761H78.001L48.5123 130.93C48.6315 125.621 49.336 119.193 50.1833 113.951C57.6147 112.163 64.7212 111.095 71.9075 108.489L72.3463 108.624C74.1207 109.409 75.9625 110.032 77.8491 110.484L78.0517 113.866C78.0373 114.196 78.1502 114.519 78.3671 114.768C78.584 115.017 78.8881 115.172 79.2164 115.203H87.403C87.7282 115.168 88.0282 115.011 88.2415 114.763C88.4549 114.514 88.5655 114.194 88.5508 113.866L88.7534 110.112C90.5257 109.351 91.4879 108.421 91.5047 107.508C91.4898 107.284 91.4306 107.065 91.3306 106.865C91.2305 106.664 91.0916 106.485 90.922 106.339C90.7523 106.192 90.5553 106.081 90.3424 106.012C90.1294 105.943 89.9049 105.916 89.6817 105.935H89.4623V105.85H89.5974C90.0868 105.57 90.5067 105.183 90.8254 104.717C91.144 104.252 91.3532 103.72 91.4372 103.161C91.4593 102.903 91.4218 102.643 91.3277 102.402C91.2336 102.161 91.0854 101.944 90.8946 101.769C90.7037 101.594 90.4753 101.466 90.227 101.393C89.9786 101.321 89.717 101.307 89.4623 101.352V101.233Z",
    fill: "#47D061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.527 208.623H159.108",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.005 208.623H198.235V222.355H11.8325V208.623H117.55",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1107 208.623H11.8325V222.355H80.1107V208.623Z",
    fill: "#47D061",
    stroke: "#333333",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.542 170.335H209.274V245H0.72583V170.335H108.469",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2774 180.347C28.7783 180.347 29.9951 179.128 29.9951 177.624C29.9951 176.12 28.7783 174.901 27.2774 174.901C25.7765 174.901 24.5598 176.12 24.5598 177.624C24.5598 179.128 25.7765 180.347 27.2774 180.347Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6729 180.347C19.1739 180.347 20.3906 179.128 20.3906 177.624C20.3906 176.12 19.1739 174.901 17.6729 174.901C16.172 174.901 14.9553 176.12 14.9553 177.624C14.9553 179.128 16.172 180.347 17.6729 180.347Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06845 180.347C9.56936 180.347 10.7861 179.128 10.7861 177.624C10.7861 176.12 9.56936 174.901 8.06845 174.901C6.56755 174.901 5.35083 176.12 5.35083 177.624C5.35083 179.128 6.56755 180.347 8.06845 180.347Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0863 85.438H77.4777C77.2996 85.4608 77.1279 85.5189 76.9726 85.609C76.8172 85.6991 76.6814 85.8193 76.5729 85.9626C76.4645 86.1058 76.3856 86.2694 76.341 86.4435C76.2964 86.6177 76.2868 86.799 76.313 86.977L76.4818 90.0549L76.6168 92.6762L76.7518 95.2468L76.8362 96.7689V96.9041",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1245 96.2277L89.2933 93.1667L89.6309 86.977C89.6571 86.799 89.6475 86.6177 89.6029 86.4435C89.5583 86.2694 89.4794 86.1058 89.371 85.9626C89.2625 85.8193 89.1267 85.6991 88.9713 85.609C88.816 85.5189 88.6443 85.4608 88.4662 85.438H87.7742",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7815 110.484V110.586L77.984 113.968C77.9697 114.298 78.0826 114.621 78.2995 114.87C78.5163 115.118 78.8205 115.274 79.1487 115.304H87.3354C87.6606 115.27 87.9606 115.113 88.1739 114.864C88.3873 114.616 88.4979 114.295 88.4832 113.968L88.6858 110.214V110.095",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7856 96.6335V96.7688C78.2373 100.557 87.0485 98.7305 89.074 96.2276C89.2088 96.0653 89.3171 95.8827 89.3947 95.6864C89.3947 95.6864 89.3947 95.6864 89.3947 95.585",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4622 95.6864C89.7275 95.6664 89.9939 95.7038 90.2434 95.7959C90.493 95.888 90.7199 96.0328 90.9087 96.2204C91.0976 96.408 91.244 96.6341 91.3381 96.8834C91.4322 97.1326 91.4717 97.3992 91.454 97.6651C91.3873 98.3657 91.1757 99.0448 90.8328 99.6592C90.4899 100.273 90.0231 100.81 89.4622 101.233C88.3504 102.094 87.0648 102.702 85.6947 103.015C84.3246 103.327 82.903 103.337 81.5288 103.043",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4622 101.352C89.7169 101.307 89.9785 101.321 90.2269 101.394C90.4752 101.466 90.7036 101.594 90.8945 101.769C91.0853 101.944 91.2335 102.161 91.3276 102.402C91.4217 102.643 91.4592 102.903 91.4371 103.161C91.3531 103.72 91.1439 104.252 90.8253 104.717C90.5066 105.183 90.0868 105.571 89.5973 105.85H89.4622C87.1141 107.238 84.3492 107.742 81.6638 107.271",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4622 106.036H89.5466C89.7697 106.018 89.9943 106.044 90.2072 106.114C90.4201 106.183 90.6172 106.294 90.7868 106.44C90.9565 106.587 91.0954 106.766 91.1954 106.966C91.2955 107.167 91.3547 107.385 91.3696 107.609C91.3696 108.438 90.3906 109.453 88.6182 110.214C85.1077 111.452 81.3035 111.588 77.714 110.603C75.8273 110.151 73.9855 109.528 72.2112 108.742",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7349 92.6593C80.1108 91.3232 81.0054 94.3504 84.3476 95.1284C85.0522 95.2753 85.7749 95.3152 86.4913 95.2467H86.7276C87.273 95.1167 87.7829 94.8672 88.2206 94.5164C88.6584 94.1655 89.0132 93.7219 89.2596 93.2173",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7276 95.0779L88.1286 85.4382L89.192 78.2507L96.9735 78.2338L97.1592 76.0015H87.2171L85.8161 85.4382L84.415 94.8581",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8025 90.0719H76.4818C75.6564 90.024 74.8623 89.739 74.1943 89.2509C73.5263 88.7628 73.0128 88.0923 72.715 87.3196C72.4173 86.5468 72.348 85.7045 72.5154 84.8933C72.6829 84.0822 73.0799 83.3365 73.6591 82.7454C74.2383 82.1543 74.9751 81.7429 75.7815 81.5602C76.5879 81.3776 77.4298 81.4315 78.2064 81.7155C78.983 81.9995 79.6616 82.5016 80.161 83.1617C80.6603 83.8219 80.9594 84.6121 81.0224 85.4381C81.0224 85.5395 81.0224 85.641 81.0224 85.7594",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4782 130.846H77.6465",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4392 15.7108C74.6586 14.2902 74.895 12.616 75.2494 10.9417C75.6662 8.15167 76.7876 5.51459 78.5072 3.2807C82.4233 -0.997974 86.5588 0.676287 90.0191 4.37996C91.0572 5.45159 92.0004 6.61159 92.838 7.84686C95.3002 11.5079 97.1794 15.5302 98.4083 19.7696C99.8093 25.6549 91.3526 38.7108 88.9895 39.624C88.71 39.7282 88.422 39.8074 88.1286 39.8608C84.6345 40.4527 80.2627 37.2902 78.811 34.1954",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7175 51.7162C72.8694 41.8567 72.4475 32.9104 73.4265 23.1016",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9431 39.438L88.0444 39.8608C88.8377 43.7336 89.0065 48.5027 90.4919 52.0034V52.1894",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7897 17.5035C75.3797 16.8751 74.8856 16.306 74.3212 15.8123C70.4388 12.43 67.755 19.9049 69.2573 22.0527C69.6965 22.5507 70.2658 22.9158 70.901 23.1071C71.5363 23.2983 72.2122 23.308 72.8526 23.1351L73.2915 23.0336C73.6145 22.9466 73.9261 22.8217 74.2199 22.6616",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72 7.84724C93.6484 7.84724 106.815 5.29357 104.992 1.5899C103.945 -0.524072 96.9737 1.5899 89.9855 4.38033C83.3687 7.01856 76.735 10.2318 75.2158 10.9421L74.9626 11.0436",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9307 20.7336C92.2369 20.1632 93.6867 20.0097 95.0831 20.2939",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7784 20.8522C86.1555 20.4261 85.4082 20.2213 84.6556 20.2703C83.903 20.3194 83.1885 20.6195 82.626 21.1228",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5783 18.8398C72.8413 19.4793 71.9031 19.8385 70.9282 19.8545",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88 20.7505C90.0361 22.6277 90.88 25.5872 91.2514 27.5152C91.4371 28.8512 91.7071 31.4218 89.2258 30.5424",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.261 167.68C134.109 163.993 133.923 161.169 133.67 158.92C131.661 141.365 117.111 131.015 81.5793 130.846",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.814 221.865C135.805 221.719 135.805 221.572 135.814 221.426V221.29C135.459 210.348 135.223 201.233 135.02 193.606C135.02 193.217 135.02 192.845 135.02 192.473C134.869 186.114 134.733 180.82 134.615 176.373C134.615 175.257 134.615 174.208 134.514 173.193C134.514 171.181 134.396 169.354 134.328 167.714",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.718 176.288C109.718 176.169 109.718 176.051 109.617 175.899L109.313 174.8C108.857 173.227 108.266 171.13 108.047 170.352H74.9795C74.2593 170.352 73.5503 170.352 72.8526 170.352C62.0834 169.997 55.973 164.061 52.4451 156.146C49.0692 148.519 48.3603 139.065 48.5122 131.032C48.6314 125.723 49.1165 120.428 49.9638 115.186C50.082 114.509 50.1664 114.07 50.1833 113.951",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.476 221.307H120.2C118.411 210.839 116.335 201.554 114.36 193.639C112.672 186.621 110.984 180.685 109.583 175.933L109.279 174.833",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.088 190.815C165.876 185.015 162.923 177.286 160.323 170.386C157.403 162.742 154.938 156.298 154.466 155.165C146.853 136.224 146.178 130.711 108.367 130.711H106.139L81.5795 130.846H78.001L48.5122 131.015",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.244 167.68C135.358 169.997 137.789 174.225 140.776 179.163C143.494 183.661 146.667 188.769 149.689 193.572C152.71 198.374 155.884 203.262 158.129 206.61L171.464 199.491L169.235 193.639L168.172 190.849",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5793 31.7773C81.7499 32.2645 82.0294 32.706 82.3965 33.0682C82.7637 33.4303 83.2087 33.7035 83.6975 33.8667C84.1863 34.03 84.7059 34.079 85.2165 34.0099C85.7271 33.9409 86.2151 33.7557 86.6432 33.4685",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.406 62.5734L148.76 62.0492C151.157 58.1764 149.064 54.3543 149.216 53.2382C149.604 50.5999 152.238 51.4286 152.913 55.1661C153.258 56.9315 153.332 58.7393 153.132 60.5271C153.074 62.0316 152.526 63.4756 151.572 64.6389C150.618 65.8022 149.311 66.6211 147.849 66.9705V66.9705C147.393 67.8837 132.134 98.3756 124.893 95.7204C118.765 93.4543 112.115 88.4484 105.042 82.4955C102.206 80.1109 113.482 129.713 113.668 130.795H108.384",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.761 60.6455C144.659 60.8315 144.524 61.0345 144.389 61.2374",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.355 62.5733C148.498 62.4207 148.628 62.2567 148.744 62.0829C150.6 59.1571 149.368 51.2593 146.887 50.9042C146.658 50.8664 146.424 50.8958 146.212 50.9888C143.291 52.1388 147.714 55.5887 144.777 60.6623",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.389 61.2714C144.524 61.0516 144.659 60.8486 144.76 60.6457C145.5 59.3437 145.728 57.812 145.401 56.3501C145.249 55.4369 144.338 52.7648 143.342 52.3589C143.102 52.2521 142.835 52.2188 142.576 52.2631C142.317 52.3075 142.077 52.4276 141.886 52.6082C141.695 52.7889 141.561 53.0222 141.502 53.2787C141.443 53.5353 141.46 53.8036 141.553 54.0501C142.971 57.9567 142.228 59.2927 141.148 60.0538C140.067 60.8148 139.139 60.9332 138.801 61.931C138.801 62.2016 138.616 62.4891 138.498 62.7766C135.392 70.9449 126.479 79.2993 126.142 78.9442C121.382 73.8707 115.052 66.4126 108.84 59.1236C106.426 56.3332 92.8381 54.828 92.8381 54.828C92.7656 54.1889 92.5127 53.5837 92.1091 53.0835C91.7055 52.5833 91.1679 52.2087 90.5593 52.0038L89.9348 51.7839C84.3032 50.7008 78.5122 50.7583 72.9032 51.9531V51.9531H72.8019C71.774 52.5967 71.0265 53.6053 70.7089 54.7773C61.5939 56.4685 54.133 58.1597 50.4533 61.728C44.0728 67.9854 30.721 106.544 38.3337 112.852C40.2242 114.425 44.3766 114.729 50.1494 113.951C57.5027 112.768 64.7381 110.94 71.7723 108.489L72.2112 108.337L72.0761 99.7794C72.1692 98.6272 72.6628 97.5442 73.4709 96.719C74.279 95.8939 75.3505 95.379 76.4986 95.264",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.616 62.8608C138.616 62.8608 141.992 67.9344 147.748 66.9873",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0197 23.2197C94.1532 23.2197 94.2838 23.2594 94.3948 23.3337C94.5058 23.4081 94.5924 23.5137 94.6435 23.6373C94.6946 23.7609 94.7079 23.8969 94.6819 24.0282C94.6558 24.1594 94.5915 24.2799 94.4971 24.3745C94.4027 24.4691 94.2824 24.5336 94.1514 24.5597C94.0204 24.5858 93.8847 24.5724 93.7613 24.5212C93.6379 24.47 93.5325 24.3833 93.4583 24.272C93.3841 24.1608 93.3445 24.03 93.3445 23.8962C93.3445 23.7168 93.4156 23.5447 93.5422 23.4179C93.6689 23.291 93.8406 23.2197 94.0197 23.2197Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8163 23.2197C85.9498 23.2197 86.0804 23.2594 86.1914 23.3337C86.3025 23.4081 86.389 23.5137 86.4401 23.6373C86.4912 23.7609 86.5046 23.8969 86.4785 24.0282C86.4525 24.1594 86.3882 24.2799 86.2937 24.3745C86.1993 24.4691 86.079 24.5336 85.948 24.5597C85.8171 24.5858 85.6813 24.5724 85.5579 24.5212C85.4345 24.47 85.3291 24.3833 85.2549 24.272C85.1807 24.1608 85.1411 24.03 85.1411 23.8962C85.1411 23.7168 85.2122 23.5447 85.3389 23.4179C85.4655 23.291 85.6372 23.2197 85.8163 23.2197Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.183 234.329V237.288H159.26V234.075H159.192H120.2H120.183V234.329Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.188 217.891L184.748 206.797",
    stroke: "white",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.02 218.229L165.421 220.833L199.788 202.231L198.268 199.406L198.218 199.423L163.901 217.992H163.885L164.02 218.229Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0833 143.192C62.2689 149.957 57.9984 154.168 52.445 156.146C50.2703 156.91 47.9953 157.349 45.6931 157.448",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.632 199.44C172.139 199.288 173.827 199.203 176.105 199C180.707 198.718 185.25 197.814 189.609 196.311C192.209 195.28 195.146 195.145 196.986 197.242C197.5 197.837 197.895 198.526 198.15 199.271V199.423L164.391 217.772L158.162 206.831L171.632 199.44Z",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.781 98.6291C69.9156 99.3394 55.4666 101.487 51.0779 102.113C52.2153 94.4798 54.4023 87.0413 57.5765 80.0093",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.893 184.676H208.92",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.835 184.676H143.967",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.675293 184.676H112.014",
    stroke: "#333333",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.318 58.5399L158.786 33.7259C159.072 32.4258 158.032 31.2139 156.704 31.2997L146.487 31.9588C145.584 32.0171 144.832 32.6748 144.655 33.5624L139.745 58.1114C139.556 59.0541 140.277 59.9337 141.239 59.9337V59.9337",
    stroke: "#333333",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.208 35.3096C148.208 35.8228 147.792 36.2388 147.279 36.2388C146.765 36.2388 146.349 35.8228 146.349 35.3096C146.349 34.7964 146.765 34.3804 147.279 34.3804C147.792 34.3804 148.208 34.7964 148.208 35.3096Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.743 38.0972C147.743 38.6104 147.327 39.0264 146.814 39.0264C146.301 39.0264 145.885 38.6104 145.885 38.0972C145.885 37.584 146.301 37.168 146.814 37.168C147.327 37.168 147.743 37.584 147.743 38.0972Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_13717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 245.744,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedAction);
export default __webpack_public_path__ + "static/media/completedAction.6384444c8f58e5d1353cd09307ab2ece.svg";
export { ForwardRef as ReactComponent };